import AOS from 'aos';

export default class {
    constructor() {
        document.addEventListener('DOMContentLoaded', () => {
            let cssClasses = `
                .SiteNewsletter__content > h3,
                .SiteNewsletter__content > p,
                .SiteNewsletter__content > .gform_wrapper,
                .site-main .wp-block-column > h2, 
                .site-main .wp-block-column > h3, 
                .site-main .wp-block-column > h4, 
                .site-main .wp-block-column > h5, 
                .site-main .wp-block-column > p, 
                .site-main .wp-block-column > ul, 
                .site-main .wp-block-column > ol, 
                .site-main .wp-block-column > .wp-block-buttons, 
                .site-main .wp-block-group__inner-container > h2,
                .site-main .wp-block-group__inner-container > h3,
                .site-main .wp-block-group__inner-container > h4,
                .site-main .wp-block-group__inner-container > h5,
                .site-main .wp-block-group__inner-container > p,
                .site-main .wp-block-group__inner-container > ul,
                .site-main .wp-block-group__inner-container > ol,
                .site-main .wp-block-group__inner-container > .wp-block-buttons,
                .wp-block-cover__inner-container > h2,
                .wp-block-cover__inner-container > h3,
                .wp-block-cover__inner-container > h4,
                .wp-block-cover__inner-container > h5,
                .wp-block-cover__inner-container > p,
                .wp-block-cover__inner-container > ul,
                .wp-block-cover__inner-container > ol,
                .wp-block-cover__inner-container > .wp-block-buttons 
                `.replace(/\n/g, "");
            document.querySelectorAll(cssClasses).forEach(el => {
                const attributes = {
                    "data-aos": "fade-up",
                    "data-aos-duration": "400",
                    "data-aos-once": "false",
                };
                Object.keys(attributes).forEach(key => {
                    el.setAttribute(key, attributes[key]);
                });
            });

            cssClasses = `
                .site-main .wp-block-column > .responsive-image,
                .site-main .wp-block-column > .wp-block-image,
                .BlockMinitabs__contentInner.image
                `.replace(/\n/g, "");
            document.querySelectorAll(cssClasses).forEach(el => {
                const attributes = {
                    "data-aos": "fade-up",
                    "data-aos-duration": "600",
                    "data-aos-once": "false",
                    "data-aos-delay": "100",
                };
                Object.keys(attributes).forEach(key => {
                    el.setAttribute(key, attributes[key]);
                });
            });
            this.init();
        });
    }

    init() {
        AOS.init();
    }
}